import { useState } from 'react'
import { Link } from 'react-router-dom'
import { ROUTES } from '@constants'
import toast from 'react-hot-toast'

function ForgotPasswordPage() {
  const [email, setEmail] = useState('')
  const [loading, setLoading] = useState(false)
  const [success, setSuccess] = useState(false)

  const handleSubmit = async (e) => {
    e.preventDefault()
    setLoading(true)

    try {
      // Simulation d'appel API
      await new Promise(resolve => setTimeout(resolve, 1500))
      setSuccess(true)
      toast.success('Email envoyé avec succès !')
    } catch (err) {
      toast.error('Une erreur est survenue. Veuillez réessayer.')
    } finally {
      setLoading(false)
    }
  }

  if (success) {
    return (
      <div className="max-w-md mx-auto text-center animate-fade-in">
        <div className="mb-6">
          <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
            <span className="text-3xl">✓</span>
          </div>
          <h2 className="text-2xl font-bold text-darkBlue mb-2">
            Email envoyé !
          </h2>
          <p className="text-gray-600">
            Nous avons envoyé un lien de réinitialisation à <strong>{email}</strong>
          </p>
        </div>
        <p className="text-sm text-gray-500 mb-6">
          Vérifiez votre boîte de réception et suivez les instructions pour réinitialiser votre mot de passe.
        </p>
        <Link 
          to={ROUTES.LOGIN}
          className="btn-secondary w-full text-darkBlue font-bold"
        >
          Retour à la connexion
        </Link>
      </div>
    )
  }

  return (
    <div className="max-w-md mx-auto animate-slide-up">
      <div className="text-center mb-8">
        <h2 className="text-2xl font-bold text-darkBlue mb-2">
          Mot de passe oublié ?
        </h2>
        <p className="text-gray-600">
          Entrez votre adresse email et nous vous enverrons un lien pour réinitialiser votre mot de passe.
        </p>
      </div>

      <form onSubmit={handleSubmit} className="space-y-6">
        <div>
          <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-2">
            Adresse Email
          </label>
          <input
            type="email"
            id="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            placeholder="votre@email.com"
            className="input-ligdi bg-gray-50"
          />
        </div>

        <button 
          type="submit" 
          className="btn-secondary w-full disabled:opacity-50 disabled:cursor-not-allowed text-darkBlue font-bold" 
          disabled={loading}
        >
          {loading ? 'Envoi en cours...' : 'Envoyer le lien'}
        </button>
      </form>

      <div className="mt-6 text-center">
        <Link to={ROUTES.LOGIN} className="text-primary font-semibold hover:text-primary-600">
          ← Retour à la connexion
        </Link>
      </div>
    </div>
  )
}

export default ForgotPasswordPage
